import React, { Component } from "react";
import { Form } from "react-bootstrap";
import { PiTrash, PiUsers } from "react-icons/pi";
import { toast } from "react-toastify";
import axios from "../../../axios";
import "./steps.css";



const DEFAULT_EVENT_OPTIONS_BY_ATTACK = {
	Phishing: ["Email Sent", "Email Opened", "Link Clicked", "Data Submitted"],
	Ransomware: ["Email Sent", "Email Opened", "Link Clicked", "System Hacked"],
	Smishing: ["SMS Sent", "Link Clicked", "Data Submitted"],
	Vishing: ["Call Initiated", "Call Picked", "Data Submitted"],
	WhatsApp: ["Message Sent", "Link Clicked", "Data Submitted"],
	Attachment: ["Email Sent", "Email Opened", "Attachment Opened"],
	QRcode: ["Email Sent", "Email Opened", "QR Scanned", "Data Submitted"],
	Telegram: ["Message Sent", "Link Clicked", "Data Submitted"],
	"Vishing-inbound": ["Email Sent", "Email Opened", "Call Received", "Data Submitted"],
	"WhatsApp-inbound": ["Email Sent", "Email Opened", "Link Clicked", "Data Submitted"]
};

const ATTACKS_NO_CH = new Set(["Attachment", "Ransomware"]);

const EVENT_LABELS = {
	"Email Sent": "Users who were sent the email",
	"Email Opened": "Users who opened the email",
	"Link Clicked": "Users who clicked the link",
	"Data Submitted": "Users who submitted data",
	"Attachment Opened": "Users who opened the attachment",
	"SMS Sent": "Users who were sent the SMS",
	"Message Sent": "Users who were sent the message",
	"Call Initiated": "Users for whom the call was initiated",
	"Call Picked": "Users who picked the call",
	"Call Received": "Users who received the call",
	"QR Scanned": "Users who scanned the QR code",
	"System Hacked": "Users whose system was hacked",
	"Email Reported": "Users who reported the email"
};

export default class FollowUpConditionStep extends Component {
	constructor(props) {
		super(props);
		const conds = Array.isArray(props.conditions) ? props.conditions : [];
		const rows = conds.length > 0
			? conds.map((c) => ({
				event: typeof c === "object" ? (c.event || c.value || "") : "",
				operator: typeof c === "object" ? (c.operator || null) : null
			}))
			: [{ event: "", operator: null }];
		const pid = props.parentSimulationId;
		const parentSimulationId =
			pid != null && String(pid).trim() !== "" ? String(pid).trim() : "";
		this.state = {
			rows,
			matchedUserCount:
				props.matchedUserCount !== undefined && props.matchedUserCount !== null
					? props.matchedUserCount
					: null,
			isLoadingCount: props.matchedUserCountLoading === true,
			parentSimulationId
		};
	}

	componentDidMount() {
		// Refresh count when restoring step with parent + event already chosen
		if (this.state.rows[0]?.event && this.state.parentSimulationId) {
			this.fetchMatchedUserCount();
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.parentSimulationId !== this.props.parentSimulationId) {
			const v = this.props.parentSimulationId;
			this.setState({
				parentSimulationId:
					v != null && String(v).trim() !== "" ? String(v).trim() : ""
			});
		}
		if (prevProps.matchedUserCount !== this.props.matchedUserCount) {
			this.setState({
				matchedUserCount:
					this.props.matchedUserCount !== undefined ? this.props.matchedUserCount : null
			});
		}
		if (prevProps.matchedUserCountLoading !== this.props.matchedUserCountLoading) {
			this.setState({ isLoadingCount: this.props.matchedUserCountLoading === true });
		}

		if (prevProps.conditions === this.props.conditions) return;
		if (!Array.isArray(this.props.conditions)) return;

		const conds = this.props.conditions;
		if (conds.length === 0) {
			this.setState({ rows: [{ event: "", operator: null }] });
			return;
		}
		if (conds.length < this.state.rows.length) return;

		const rows = conds.map((c) => ({
			event: typeof c === "object" ? (c.event || c.value || "") : "",
			operator: typeof c === "object" ? (c.operator ?? null) : null
		}));
		this.setState({ rows }, () => {
			// Fetch count after updating rows from props
			if (rows[0]?.event) {
				this.fetchMatchedUserCount();
			}
		});
	}

	defaultEventOptions = (attackType, targetInteractionType) => {
		let eventValues = [];
		let attackTypeKey = attackType;
		if (targetInteractionType === "inbound" && attackType === "Vishing") {
			attackTypeKey = "Vishing-inbound";
		} else if (targetInteractionType === "inbound" && attackType === "WhatsApp") {
			attackTypeKey = "WhatsApp-inbound";
		}
		const credentialHarvestingEnabled =
			this.props.credentialHarvesting === true || this.props.credentialHarvesting === "true";
		const isIndependentFinalEvent =
			ATTACKS_NO_CH.has(attackType) ||
			(attackType === "Vishing" && targetInteractionType !== "inbound") ||
			(attackType === "WhatsApp" && targetInteractionType !== "inbound"); //Understand this whether it should be placed here or not
		eventValues = attackType && DEFAULT_EVENT_OPTIONS_BY_ATTACK[attackTypeKey]
			? DEFAULT_EVENT_OPTIONS_BY_ATTACK[attackTypeKey]
			: [...new Set(Object.values(DEFAULT_EVENT_OPTIONS_BY_ATTACK).flat())];
		if (
			attackType &&
			!credentialHarvestingEnabled &&
			!isIndependentFinalEvent &&
			eventValues.length > 0
		) {
			eventValues = eventValues.slice(0, -1);
		}
		return eventValues.map((value) => ({
			value,
			label: EVENT_LABELS[value] || value
		}));
	}

	getEventOptions = () => {
		if (this.props.eventOptions && Array.isArray(this.props.eventOptions)) {
			return this.props.eventOptions;
		}
		const attackType = this.props.attackType || "";
		const targetInteractionType = this.props.targetInteractionType || "inbound";
		return this.defaultEventOptions(attackType, targetInteractionType);
	};

	/** Returns options for a row: row 0 gets all; row 1+ gets only options after the previous row's selection */
	getOptionsForRow = (rowIndex) => {
		const allOptions = this.getEventOptions();
		if (rowIndex === 0) return allOptions;

		const prevRow = this.state.rows[rowIndex - 1];
		if (!prevRow || !prevRow.event) return allOptions;

		const prevIndex = allOptions.findIndex((o) => o.value === prevRow.event);
		if (prevIndex < 0 || prevIndex >= allOptions.length - 1) return [];

		return allOptions.slice(prevIndex + 1);
	};

	addCondition = (operator) => {
		this.setState(
			(prev) => ({
				rows: [...prev.rows, { event: "", operator }]
			}),
			() => this.syncToParent()
		);
	};

	removeRow = (index) => {
		this.setState(
			(prev) => {
				const rows = prev.rows.filter((_, i) => i !== index);
				const next = rows.length ? rows : [{ event: "", operator: null }];
				// First row always has operator null
				if (next.length && next[0].operator != null) next[0] = { ...next[0], operator: null };
				return { rows: next };
			},
			() => this.syncToParent()
		);
	};

	updateRow = (index, value) => {
		this.setState(
			(prev) => {
				const rows = [...prev.rows];
				rows[index] = { ...rows[index], event: value };
				// Clear rows below since their options depend on this row
				for (let i = index + 1; i < rows.length; i++) {
					rows[i] = { ...rows[i], event: "" };
				}
				return { rows };
			},
			() => this.syncToParent()
		);
	};

	syncToParent = () => {
		const options = this.getEventOptions();
		const getLabel = (val) => (val ? (options.find((o) => o.value === val)?.label || val) : "");

		const conditions = this.state.rows
			.filter((r) => r.event)
			.map((r) => ({ event: r.event, operator: r.operator }));

		// { label, operator } so operator can be shown in badge, label shown as text
		const conditionsDisplay = conditions.map((c, i) => ({
			event: c.event,
			label: getLabel(c.event),
			operator: i === 0 ? null : (c.operator || "AND")
		}));

		const pid = this.state.parentSimulationId;
		const parentSimulationId =
			pid != null && String(pid).trim() !== "" ? String(pid).trim() : "";

		if (this.props.onUpdate) {
			this.props.onUpdate({ conditions, conditionsDisplay, parentSimulationId });
		}

		// Fetch matched user count after syncing
		this.fetchMatchedUserCount();
	};

	/** Sends only count/loading keys so parent does not overwrite conditions and retrigger fetch loops. */
	notifyParentMatchedCount = (patch) => {
		if (!this.props.onUpdate || !patch || typeof patch !== "object") return;
		this.props.onUpdate(patch);
	};

	handleParentSimulationChange = (e) => {
		const raw = e.target.value;
		this.setState({ parentSimulationId: raw }, () => this.syncToParent());
	};

	fetchMatchedUserCount = () => {
		const simulationId = this.state.parentSimulationId;

		const filledRows = this.state.rows.filter((r) => r.event);

		if (!simulationId || String(simulationId).trim() === "" || filledRows.length === 0) {
			this.setState({ matchedUserCount: null, isLoadingCount: false }, () =>
				this.notifyParentMatchedCount({ matchedUserCount: null, matchedUserCountLoading: false }));
			return;
		}

		const simulationState1 = filledRows[0]?.event;
		const simulationState2 = filledRows[1]?.event || null;

		if (!simulationState1) {
			this.setState({ matchedUserCount: null, isLoadingCount: false }, () =>
				this.notifyParentMatchedCount({ matchedUserCount: null, matchedUserCountLoading: false }));
			return;
		}

		this.notifyParentMatchedCount({ matchedUserCountLoading: true });
		this.setState({ isLoadingCount: true });

		const params = new URLSearchParams({
			simulationId: simulationId.toString(),
			simulationState1
		});

		if (simulationState2) {
			params.append("simulationState2", simulationState2);
		}

		axios
			.get(`/api/simulation/matched-user-count?${params.toString()}`)
			.then((response) => {
				if (response.data && response.data.success) {
					const raw = response.data.matchedUserCount;
					const count = typeof raw === "number" && !Number.isNaN(raw) ? raw : parseInt(raw, 10);
					const n = Number.isFinite(count) ? count : 0;
					this.setState({
						matchedUserCount: n,
						isLoadingCount: false
					}, () =>
						this.notifyParentMatchedCount({
							matchedUserCount: n,
							matchedUserCountLoading: false
						}));
				} else {
					this.setState({ matchedUserCount: null, isLoadingCount: false }, () =>
						this.notifyParentMatchedCount({
							matchedUserCount: null,
							matchedUserCountLoading: false
						}));
				}
			})
			.catch((error) => {
				console.error("Error fetching matched user count:", error);
				this.setState({
					matchedUserCount: null,
					isLoadingCount: false
				}, () =>
					this.notifyParentMatchedCount({
						matchedUserCount: null,
						matchedUserCountLoading: false
					}));
			});
	};


	validate = () => {
		const pid = this.state.parentSimulationId;
		if (pid == null || String(pid).trim() === "") {
			toast.error("Please select a target campaign");
			return false;
		}
		const first = this.state.rows[0];
		if (!first || !first.event) {
			toast.error("Please select an event for the first condition");
			return false;
		}
		const emptyRow = this.state.rows.find((r, i) => i > 0 && !r.event);
		if (emptyRow !== undefined) {
			toast.error("Please select an event for each added condition or remove the row");
			return false;
		}
		if (this.state.isLoadingCount) {
			toast.error("Please wait for matched user count to finish loading");
			return false;
		}
		if (
			this.state.matchedUserCount == null ||
			(typeof this.state.matchedUserCount === "number" && this.state.matchedUserCount < 1)
		) {
			toast.error("At least one user must match the selected target campaign and event");
			return false;
		}
		return true;
	};

	render() {

		return (

			<div className="step-content-wrapper">
				<div className="step-header">
					<h4>Select Condition</h4>
					<p>Select conditions to target users based on their actions in the primary campaign.</p>
				</div>
				<div className="follow-up-condition-form">
					<Form.Group className="condition-event-group mb-0">
						<Form.Label>
							Select Target Campaign {<span className="red-star">*</span>}
						</Form.Label>
						<div className="condition-event-input-wrap">
							<Form.Control
								as="select"
								value={this.state.parentSimulationId ?? ""}
								onChange={this.handleParentSimulationChange}
							>
								<option value="">Select Target Campaign</option>

								{/* {resolvedSimulations.filter((simulation) => new Date(simulation.completedAt)<new Date())
										.map((simulation) => {
											return (
											<option key={simulation.id} value={simulation.id}>
												{simulation.label}
											</option>
											);
										})} */}
								{this.props.simulations.filter(simulation => new Date(simulation.completedAt) < new Date()).map(simulation => {
									return (
										<option key={simulation.id} value={simulation.id}>
											{simulation.name}
										</option>
									)
								})}
							</Form.Control>
						</div>
					</Form.Group>

					{this.state.rows.map((row, index) => {
						const rowOptions = this.getOptionsForRow(index);
						return (
							<div key={index} >
								{index > 0 && (
									<div className={`condition-operator-badge condition-operator-badge-${(row.operator).toLowerCase()}`}>
										{row.operator}
									</div>
								)}
								<Form.Group className="condition-event-group mb-0">
									<Form.Label>
										Select Event {index === 0 && <span className="red-star">*</span>}
									</Form.Label>
									<div className="condition-event-input-wrap">
										<Form.Control
											as="select"
											value={row.event}
											onChange={(e) => this.updateRow(index, e.target.value)}
										>
											<option value="">Select Event</option>
											{rowOptions.map((opt, i) => (
												<option key={i} value={opt.value}>{opt.label}</option>
											))}
										</Form.Control>
										<button
											type="button"
											className="condition-remove-btn condition-row-delete"
											onClick={() => this.removeRow(index)}
											title={index === 0 ? "Clear selection" : "Remove condition"}
											aria-label={index === 0 ? "Clear selection" : "Remove condition"}
										>
											<PiTrash />
										</button>
									</div>
								</Form.Group>
							</div>
						);
					})}
					{this.state.rows.length < 2 && (
						<div className="condition-add-buttons">
							<button
								type="button"
								className="condition-add-btn"
								onClick={() => this.addCondition("NOT")}
								disabled={!this.state.rows[0]?.event}
							>
								+ NOT
							</button>
						</div>
					)}

					<p className="condition-user-count-text">
						<PiUsers /> {" "}
						{this.state.isLoadingCount ? (
							"Loading user count..."
						) : this.state.matchedUserCount !== null ? (
							`${this.state.matchedUserCount} User${this.state.matchedUserCount !== 1 ? 's' : ''} found`
						) : (
							"Select a condition to see matched users"
						)}
					</p>
				</div>
			</div>
		);
	}
}
